import React, { useState, useEffect } from 'react';


import '../postAd/postAd.css';





import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';


import { IoLayersOutline } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";

import { HiOutlineArrowLongRight } from "react-icons/hi2";

import TagInput from '../../components/property/tagInput';
import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2'
import config from '../../config/config';


import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import AccountSidebar from '../../components/sidebar/accountSidebar';
import MultiImageUpload from '../../components/upload/multipleImageUpload'

import {connect} from 'react-redux';
import * as actionPropertyType from '../../store/propertyType/actions';
import * as locationActions from '../../store/location/actions';
import * as postDataActions from '../../store/postData/actions';

import { useNavigate, useParams, useLocation } from "react-router-dom";

import * as actions from '../../store/property/actions';




const UpdateProperty =({ getProperty, detail, getPropertyTypes, propertyTypeWithAttributes, fetchLocations, suggestedLocation, updateProperty }) => {  
    const navigate = useNavigate();
    let match = useParams("/detail/:slug"); 
    const [activeStep, setActiveStep ] = useState('step-1');
    const [ formData, setFormData ] = useState('');
    const [ postAdData2, setPostAdData2 ] = useState('');
    const [ errors, setErrors ] = useState('');
    const [tags, setTags] = useState([]);
    const [ propertyAttributesValues, setPropertyAttributesValues ] = useState('');
    const [ isRent, setIsRent ] = useState(false);
    const [ propertyTypes, setPropertyTypes ] = useState();
    const [ propertyTypeSubCategory, setPropertyTypeSubCategory ] = useState('');
    const [ attributeValues, setAttributeValues ] = useState('');
    const [ propertyAttributes, setPropertyAttributes ] = useState('');
    const [ uploadImages, setUploadImages ] = useState([]);
    const [ resultText, setResultText ] = useState('');
    const [ activeLocationId, setActiveLocationID ] = useState('');
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
		loadData();
	},[]);
    console.log('detail', detail)
    useEffect(() => {
        if(detail && detail != ''){
            if(detail && detail.attributes && detail.attributes.length > 0){
                let values = [];
                detail.attributes.forEach((value, index) => {
                    // values.append(value.code, value.value); // Use '[]' if backend expects an array
                    setFormData((prevState) => ({...prevState, [value.code]: value.value}));
                    if(value.code == 'is_rent'){
                        setIsRent(true);
                        setFormData((prevState) => ({...prevState, property_list_type: 'rent'}));
                    } else {
                        setFormData((prevState) => ({...prevState, property_list_type: 'sale'}));
                    }
                    setFormData((prevState) => ({...prevState, property_list_type: detail.title}));

                    if(detail.is_pre_leased_property){
                        setFormData((prevState) => ({...prevState, is_pre_leased_property: detail.is_pre_leased_property}));
                        setFormData((prevState) => ({...prevState, is_pre_leased_property: detail.is_pre_leased_property_rent}));
                    }
                    
                    setFormData((prevState) => ({...prevState, token: localStorage.getItem('user')}));
                    setFormData((prevState) => ({...prevState, entity_id: detail.entity_id}));
                    setFormData((prevState) => ({...prevState, city: detail.city}));
                    setFormData((prevState) => ({...prevState, title: detail.title}));
                    setFormData((prevState) => ({...prevState, property_type: detail.property_type_type}));
                    setFormData((prevState) => ({...prevState, property_type_subcategory: detail.property_type_id}));
                    setFormData((prevState) => ({...prevState, property_type_id: detail.property_type_id}));
                    setFormData((prevState) => ({...prevState, location: detail.location}));
                    
                });
                // console.log('values', formData);
                setPostAdData2(detail.attributes);
            }
        }

	},[detail]);

    useEffect(() => {
        if(propertyTypeWithAttributes){
            // console.log('propertyTypeWithAttributes', propertyTypeWithAttributes, detail.property_type_type)
		    setPropertyTypes(propertyTypeWithAttributes);

            if(detail.property_type_type == 'Residential'){
                setPropertyTypeSubCategory(propertyTypeWithAttributes['residential_properties'])
                // setAttributeValues(propertyTypeWithAttributes['residential_properties'][''])
                const matchedProperty = propertyTypeWithAttributes['residential_properties'].find(
                    (property) => property.property_type_id === parseInt(detail.property_type_id)
                );
                // console.log('matchedProperty', matchedProperty.attributes)
                setPropertyAttributes(matchedProperty.attributes);
                setAttributeValues(matchedProperty.attributes_values)
            } else if(detail.property_type_type == 'Commercial'){
                setPropertyTypeSubCategory(propertyTypeWithAttributes['commercial_properties']);
                const matchedProperty = propertyTypeWithAttributes['commercial_properties'].find(
                    (property) => property.property_type_id === parseInt(detail.property_type_id)
                );
                // console.log('matchedProperty', matchedProperty.attributes)
                setPropertyAttributes(matchedProperty.attributes);
                setAttributeValues(matchedProperty.attributes_values);
            }
        }
	},[propertyTypeWithAttributes]);

    // console.log(detail)

    const loadData = async() => {
        await getProperty({property: match.slug});
        await getPropertyTypes().then(res => {
            // console.log()
        })
    }

    const setAnimities = (aimities) => {
        setTags(aimities);
        setFormData((prevState) => ({
            ...prevState,
            other_amenities: aimities,
        }));
    }

    const renderFormFields = (item) => {
        if(item.frontend_input == 'input_box'){
           return renderInputBox(item);
        } else if(item.frontend_input == 'select'){
            return renderSelectBox(item);
        } else if(item.frontend_input == "radio_button"){
            return renderCheckBox(item);
        } else if(item.frontend_input == "checkbox"){
            return renderCheckBox(item);
        } else if(item.frontend_input == 'text'){
            return renderTextArea(item)
        } else if(item.frontend_input == 'boolean'){
            return renderCheckBox(item)
        }
    }

    const renderSelectBox = (item) => {
        // console.log(item.select_options)
        if(item.select_options != null){
            const options = item.select_options.split(",");
            return <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                    <Form.Group className="form-group" controlId="formGridEmail" >
                        <Form.Label>{item.frontend_label}:</Form.Label>
                        <Form.Select aria-label="Default select example" name={item.attribute_code} defaultValue={formData[item.attribute_code]} onChange={handleChange}>
                            <option>Choose</option>
                            {
                                options.map((optionVlaue, index) => {
                                    return <option value={optionVlaue} key={`${item.attribute_code}-${index}`}>{optionVlaue}</option>
                                })
                            }
                        </Form.Select>
                    </Form.Group>
                    </Col>
        } else {
            <Col className='mb-3' md={6}><Form.Group className="form-group" controlId="formGridEmail">
                <Form.Label>{item.frontend_label}:</Form.Label>
                <Form.Select aria-label="Default select example" defaultValue={formData[item.attribute_code]} onChange={handleChange} name={item.attribute_code} className={errors[item.attribute_code] ? 'input-error' : ''}>
                    <option>Choose</option>
                    
                </Form.Select>
            </Form.Group>
            </Col>
        }
    }

    const renderCheckBox = (item) => {
        // console.log(postAdData.formData.property_list_type)
        return (item.attribute_code == 'is_pre_leased_property' && formData.property_list_type == 'sale') ?
                <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                    <Form.Group className="form-group align-items-bottom" controlId="formGridPassword">
                        <Form.Label>{item.frontend_label}</Form.Label>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label={formData[item.attribute_code] ? 'Yes' : 'No'} 
                            name={item.attribute_code} 
                            onChange={handleChangeCheckbox} 
                            checked={formData[item.attribute_code]}
                            className={errors[item.attribute_code] ? 'input-error' : ''}
                            defaultValue={formData[item.attribute_code]}
                        />
                    </Form.Group>
                </Col>
            : item.attribute_code != 'is_pre_leased_property' ?
                <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                    <Form.Group className="form-group align-items-bottom" controlId="formGridPassword">
                        <Form.Label>{item.frontend_label}</Form.Label>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            label={formData[item.attribute_code] ? 'Yes' : 'No'} 
                            name={item.attribute_code} 
                            onChange={handleChangeCheckbox} 
                            checked={formData[item.attribute_code]}
                            className={errors[item.attribute_code] ? 'input-error' : ''}
                            defaultValue={formData[item.attribute_code]}
                        />
                    </Form.Group>
                </Col>
            : null
            
    }

    const renderInputBox = (item) => {
        // console.log('item', item, formData)
        if(item.attribute_code == 'other_amenities'){
            return <Col className='mb-3' md={12} key={`attributefield${item.attribute_id}`}>
                <Form.Label>{item.frontend_label}</Form.Label>
                <TagInput tags={tags} setAnimities={setAnimities} />
            </Col>
        } else {
            return (formData.is_pre_leased_property == true && item.attribute_code == 'is_pre_leased_property_rent' && formData.property_list_type == 'sale') ? 
                <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                    <Form.Group  className="form-group"  controlId="formGroupLocation" defaultValue={formData[item.attribute_code]}>
                        <Form.Label>{item.frontend_label}</Form.Label>
                        <Form.Control type="text" placeholder={item.frontend_label} name={item.attribute_code}
                            className={errors[item.attribute_code] ? 'input-error' : ''}
                            onChange={handleChange} 
                            // className={ errors.location ? "input-error mb-3" : "mb-3"}
                        />
                    </Form.Group> 
                </Col>
                : item.attribute_code != 'is_pre_leased_property_rent' ? 
                    <Col className='mb-3' md={6} key={`attributefield${item.attribute_id}`}>
                        <Form.Group  className="form-group"  controlId="formGroupLocation">
                            <Form.Label>{item.frontend_label} </Form.Label>
                            <Form.Control type="text" placeholder={item.frontend_label} name={item.attribute_code}
                                className={errors[item.attribute_code] ? 'input-error' : ''}
                                onChange={handleChange} 
                                defaultValue={formData[item.attribute_code]}
                            />
                        </Form.Group> 
                    </Col>
                : null
        }
        
        // is_pre_leased_property_price // is_pre_lease_property_rent
    }

    const renderTextArea = (item) => {
        return <Col md={12} className='mb-3' key={`attributefield${item.attribute_id}`}>
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>Description of property: </Form.Label>
                        <Form.Control  name={item.attribute_code}
                            as="textarea"
                            placeholder={item.frontend_label}
                            style={{ height: '100px' }} 
                            onChange={handleChange} 
                            className={errors[item.attribute_code] ? 'input-error' : ''} 
                            defaultValue={formData[item.attribute_code]}
                            />
                    </Form.Group>
                </Col>
    }
    const updateInputValue = (value) => {
        setFormData({
            ...formData,
            location: value
        });
    }

    const updateImages = (images) => {
        // console.log('parent', images)
        // setCurrentImages(images);
        setUploadImages((prevImages) => [...prevImages, ...images]);
        // console.log('mergeImage', mergeImage)
        // setUploadImages(mergeImage);
    }

    // Handle input changes dynamically
    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        }));
        
        // Validate field when user types
        validateField(name, value);
    };
    // When Click on Location and try to find out location
    const handleInputChange = (event) => {
        
        const { name, value } = event.target;
        setInputValue(value);
        setFormData({
            ...formData,
            [name]: value
        });
        
        // Fetch suggestions from the server when the input changes
        fetchLocations({searchTerm: value}).then(res => {
            if(value.length > 4 && res.payload.data && res.payload.data.length == 0){
                setResultText('No Results Found');
            } else {
                setResultText('');
            }
        });
    };
    const handleChangeCheckbox = (e) => { 
        const { name, checked } = e.target;
        
        setFormData((prevState) => ({
            ...prevState,
            [name]: checked ? 1 : 0, // Update checkbox state
        }));
        // Validate field when user types
        validateField(name, checked);
    }
    // When Change Property type then change values of 
    const handlePropertyTypeChange = (event) => {
        const { name, value } = event.target;
        if(value == 'Residential'){
            setPropertyTypeSubCategory(propertyTypes['residential_properties'])
        } else if(value == 'Commercial'){
            setPropertyTypeSubCategory(propertyTypes['commercial_properties'])
        }
        
        setFormData({
            ...formData,
            [name]: value
        });
    }
    // Validation function
    const validateField = (name, value) => { 
        const matchedAttribute = attributeValues.find(attr => attr.attribute_code === name);
        
        if(matchedAttribute.is_required){
            let errorMsg = "";

            if (!value) {
                errorMsg = `${name.replace(/_/g, " ")} is required`;
            }

            setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
            }));
        }
    };

    const findFormErrors = () => {
        const { property_list_type, city, property_type_subcategory, property_type, location} = formData
        let newErrors = {}

        
        if ( !property_list_type || property_list_type === '' ) newErrors.property_list_type = 'Authenticity cannot be blank!'
        if ( !city || city== '' ) newErrors.city = 'Enter City address'
        if ( !property_type_subcategory || property_type_subcategory === '' ) newErrors.property_type_subcategory = 'Select sub-category'
        if ( !property_type || property_type === '' ) newErrors.property_type = 'Select property type'
        if ( !location || location === '' ) newErrors.location = 'Enter pocation'
        
        // console.log('newErrors', newErrors)
        setErrors(newErrors);
        return newErrors
    }

    const handleSubmit = async (event) => { 
        
        const checkErrors = findFormErrors();
		const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if ( Object.keys(checkErrors).length > 0 ) { console.log('hi', checkErrors)
            // We got errors!
            setErrors(checkErrors);
            // console.log('check 3');
        } else {
            updateProperty(formData);
            navigate(`/properties`);
        }
    }
    
    return (
        <div>
            <Header/>            
                <section className='pt-5 pb-5'>
                    {
                    detail ?
                    <Container>
                    <Row className='justify-content-center'>
                        <AccountSidebar />
                        <Col lg={9}>
                            <div className="card shadow">
                                <div>
                                    <ul className='d-flex flex-row process_tab w-100 m-0 p-0 justify-content-'>
                                        <li className='active'>
                                            <a href='#' className='d-flex align-items-center' onClick={()=> setActiveStep('step-1')}>
                                                <i>
                                                    <span className='layer'><IoLayersOutline /></span>
                                                    <span className='check'><IoCheckmarkSharp /></span>
                                                </i>
                                                <div>
                                                    <div>Steps 01</div>
                                                    <p className='mb-0'>Ads Information</p>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a href='#' className='d-flex align-items-center' onClick={()=> setActiveStep('step-2')}>
                                                <i>
                                                    <span className='layer'><IoLayersOutline /></span>
                                                    <span className='check'><IoCheckmarkSharp /></span>
                                                </i>
                                                <div>
                                                    <div>Steps 02</div>
                                                    <p className='mb-0'>Property Details </p>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <form className='p-4' onSubmit={handleSubmit}>
                                    <div id="step-1" className={activeStep != 'step-1' ? 'd-none' : ''}>
                                        <Row className="mb-3">
                                            {/* <Form.Group as={Col}  controlId="formGroupLocation">
                                                <Form.Label>Property Name</Form.Label>
                                                <Form.Control type="text" placeholder="Property Title" name="title" 
                                                    onChange={handleChange} 
                                                    defaultValue={formData.title}
                                                    className={ errors.title ? "input-error mb-3" : "mb-3"}
                                                />
                                            </Form.Group> */}
                                            <Form.Group as={Col}  controlId="formGroupLocation">
                                                <Form.Label>Location</Form.Label>
                                                <div className='position-relative'>
                                                    <Form.Control type="text" placeholder="Location" name="location" 
                                                        value={inputValue ? inputValue : formData.location} 
                                                        onChange={handleInputChange} 
                                                        
                                                        className={ errors.location ? "input-error mb-3" : "mb-3"}
                                                    />
                                                    { 
                                                        suggestedLocation && suggestedLocation.length > 0 ?
                                                            <div className="autocomplete-result">
                                                                <ul>
                                                                {
                                                                    suggestedLocation.map((location, index) => {
                                                                        return <li key={`top30Trendingside${index}`} className={activeLocationId == location.location_id ? 'active' : ''} onClick={() => setActiveLocationID(location.location_id)}>
                                                                                    
                                                                                    <div className="content">
                                                                                        <div>
                                                                                            <div className="track-name">
                                                                                                <div className="text-2" dangerouslySetInnerHTML={{__html: location.location_name}} onClick={() => updateInputValue(location.location_name)}></div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                            </li>
                                                                    })
                                                                    
                                                                }
                                                                </ul>
                                                            </div>
                                                        : ''
                                                    }
                                                </div>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} controlId="formGridEmail" >
                                                <Form.Label>Type of Property</Form.Label>
                                                <Form.Select aria-label="Default select example" className={ errors.property_type ? "input-error mb-3" : "mb-3"} onChange={handlePropertyTypeChange} name="property_type" defaultValue={formData.property_type}>
                                                    <option>Choose Property Type</option>
                                                    <option value="Commercial" >Commercial Property</option>
                                                    <option value="Residential" >Residential Property</option>
                                                </Form.Select>
                                            </Form.Group>
                                            <Form.Group as={Col} controlId="formGridEmail">
                                                <Form.Label>Sub-Category</Form.Label>
                                                <Form.Select aria-label="Default select example" className={ errors.property_type_subcategory ? "input-error mb-3" : "mb-3"} name="property_type_subcategory" onChange={handleChange} defaultValue={formData.property_type_id}>
                                                    <option>Choose</option>
                                                    {
                                                        propertyTypeSubCategory ?
                                                            propertyTypeSubCategory.map((subcategory) => (
                                                            <option key={`subcategory${subcategory.property_type_id}`} value={subcategory.property_type_id} >
                                                                {subcategory.title}
                                                            </option>
                                                            ))
                                                        : ''
                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        </Row>
                                        <Row className="mb-3">
                                            <Form.Group as={Col} controlId="formGridEmail">
                                                <Form.Label>Authenticity</Form.Label>
                                                <Form.Select aria-label="Default select example" className={ errors.property_list_type ? "input-error mb-3" : "mb-3"} name="property_list_type" onChange={handleChange} defaultValue={isRent ? 'rent' : 'sale'}>
                                                    <option>Choose Property to be list in</option>
                                                    <option value="rent" >Rent</option>
                                                    <option value="sale" >Sale</option>
                                                </Form.Select>
                                            </Form.Group>
                                            <Form.Group as={Col}  controlId="formGroupCity">
                                                <Form.Label>City</Form.Label>
                                                <Form.Control type="email" placeholder="City" disabled name="city" defaultValue={'Jaipur'} onChange={handleChange} />
                                            </Form.Group>
                                        </Row>
                                        <Row>
                                            {
                                            detail.images && detail.images.length > 0 ?
                                            <Col>
                                                <div className="uploaded-images">
                                                {
                                                    detail.images.map((uploadedImage, index) => {
                                                        return <img src={`${config.uploadUrl}${uploadedImage.image_url}`} style={{maxWidth: '100px', marginRight: '5px'}} />
                                                    })
                                                }
                                               
                                                </div>
                                                
                                            </Col>
                                            : ''
                                            }
                                            <Col>
                                                <MultiImageUpload updateImages={updateImages} />
                                            </Col>
                                        </Row>
                                    </div>
                                    <div id="step-2" className={activeStep != 'step-2' ? 'd-none' : ''}>
                                        <Row>
                                        {
                                            Object.keys(propertyAttributes).map((field, index) => (
                                                attributeValues[index].display_on_frontent ?                                                 
                                                    renderFormFields(attributeValues[index])
                                                : ''
                                            ))
                                        }
                                        </Row>
                                        <div>Step-2</div>
                                    </div>
                                    <Row className="mb-3 mt-4">
                                        <div>
                                            {/* <Button variant="light" size="lg">View posting rules</Button> */}
                                            {activeStep == 'step-1' ? <Button variant="info" size="lg" className="ms-3" onClick={()=>setActiveStep('step-2')}>Next Steps <HiOutlineArrowLongRight /></Button> : <Button variant="info" type="submit" size="lg" className="ms-3" >Update Property <HiOutlineArrowLongRight /></Button>}
                                        </div>
                                    </Row>
                                </form>
                            </div>
                        </Col>
                    </Row>
                </Container>
                    : ''
                    }
                </section>            
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    
    return {
        detail: state.property.detail,
        propertyTypeWithAttributes: state.propertyType.propertyTypeWithAttributes,
        suggestedLocation: state.location.suggestedLocation,
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
          getProperty: (post) => dispatch(actions.getProperty(post)),
          updateProperty:(post) => dispatch(actions.updateProperty(post)),
          getPropertyTypes: () => dispatch(actionPropertyType.getPropertyTypes()),
          fetchLocations: (post) => dispatch(locationActions.getAutocompleteLocation(post)),
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(UpdateProperty);